/* ═══════════════════════════════════════════════════════════════════════════
   ArtMindr — window.amfTrack

   Защо съществува този файл.
   Кодът вика window.amfTrack на 7 места (превюто, видеото на Иван, UGC
   каруселът, тръгването към чекаут), но функцията НЕ БЕШЕ дефинирана никъде.
   Тоест всяко събитие от фунията падаше в нищото: не се виждаше кой започва
   преглед, кой качва снимка, кой стига до плащане.

   Тук я дефинираме веднъж и я пращаме към всичко, което вече е инсталирано:
   Microsoft Clarity, Meta pixel, Google Analytics 4 и Shopify Web Pixels.
   Нищо ново не се зарежда — само се използва каквото вече го има.

   Ако утре добавиш друг инструмент, добави го в SINKS отдолу.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.amfTrack) return;            /* някой друг вече я е дефинирал */

  var QUEUE = [];                          /* събития отпреди инструментите да се вдигнат */
  var MAX_QUEUE = 40;

  function clean(props) {
    var out = {};
    if (!props) return out;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      var v = props[k];
      if (v === null || v === undefined) continue;
      /* Никога не изнасяме лични данни навън: имейл, телефон, име на детето,
         линк към качената снимка. Само какво се е случило, не с кого. */
      if (/mail|phone|tel|photo|url|name|имейл|телефон|снимка|име/i.test(k)) continue;
      out[k] = (typeof v === 'object') ? JSON.stringify(v).slice(0, 120) : String(v).slice(0, 120);
    }
    return out;
  }

  var SINKS = [
    /* Microsoft Clarity — за записите на сесии; слага таг, който после се филтрира */
    function (name, p) { if (window.clarity) window.clarity('event', name); },
    /* Meta pixel — като custom event, за да може да се ползва за аудитории */
    function (name, p) { if (window.fbq) window.fbq('trackCustom', name, p); },
    /* Google Analytics 4 */
    function (name, p) { if (window.gtag) window.gtag('event', name, p); },
    /* Shopify Web Pixels — стига до всяко приложение, закачено за магазина */
    function (name, p) {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, p);
      }
    }
  ];

  function send(name, props) {
    var p = clean(props);
    for (var i = 0; i < SINKS.length; i++) {
      try { SINKS[i](name, p); } catch (e) { /* един счупен инструмент не спира останалите */ }
    }
  }

  window.amfTrack = function (name, props) {
    if (!name) return;
    /* Ако нито един инструмент още не е готов, пазим събитието и го пускаме после. */
    var ready = window.clarity || window.fbq || window.gtag ||
                (window.Shopify && window.Shopify.analytics);
    if (!ready) {
      if (QUEUE.length < MAX_QUEUE) QUEUE.push([name, props]);
      return;
    }
    flush();
    send(name, props);
  };

  function flush() {
    while (QUEUE.length) { var e = QUEUE.shift(); send(e[0], e[1]); }
  }

  /* Инструментите се вдигат асинхронно — пробваме няколко пъти, после спираме. */
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (window.clarity || window.fbq || window.gtag ||
        (window.Shopify && window.Shopify.analytics)) { flush(); clearInterval(timer); }
    else if (tries > 20) { clearInterval(timer); }
  }, 500);

  document.addEventListener('DOMContentLoaded', flush);
})();
